const resolveMediaBaseUrl = () => {
  const configured = String(process.env.REACT_APP_MEDIA_URL || '').trim().replace(/\/+$/, '');
  if (configured) {
    if (window.location.protocol === 'https:' && configured.startsWith('http://')) {
      return `https://${configured.slice('http://'.length)}`;
    }
    return configured;
  }

  const { protocol, hostname } = window.location;
  if (['localhost', '127.0.0.1'].includes(hostname)) {
    return `${protocol}//${hostname}:8000`;
  }

  if (['pulsoraapp.com', 'www.pulsoraapp.com'].includes(hostname)) {
    return 'https://api.pulsoraapp.com';
  }

  if (hostname === 'beta.pulsoraapp.com') {
    return 'https://api-beta.pulsoraapp.com';
  }

  if (hostname.endsWith('.onrender.com')) {
    const serviceName = hostname.slice(0, -'.onrender.com'.length);
    if (!serviceName.endsWith('-api')) {
      return `https://${serviceName}-api.onrender.com`;
    }
  }

  return `${protocol}//${hostname}`;
};

export const imageUrl = value => {
  if (!value) return '';
  if (value.startsWith('http') || value.startsWith('blob:')) return value;
  return `${resolveMediaBaseUrl()}${value}`;
};
